import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { type AppViewNavigation } from '@/components/templates/AppView'
import { useRegion } from '@/model/contexts/useRegion.ts'

export function useTeamRegionsDropdown(): Pick<AppViewNavigation, 'teamAvailableInRegionOptions'> {
  const intl = useIntl()
  const { region } = useRegion()

  return useMemo(
    () => ({
      teamAvailableInRegionOptions: {
        placeholder: intl.formatMessage({ id: 'selector.regions.label' }),
        options: region.communities.map(({ id, name }) => ({
          value: String(id),
          text: intl.formatMessage({ id: 'selector.regions.value' }, { name }),
        })),
      },
    }),
    [intl, region.communities]
  )
}
